import { http } from '../http'

export interface Tenant {
  id: string
  name: string
  plan: string
}

// Resposta do backend para GET /company
interface CompanyDto {
  id: string
  razaoSocial: string
  subscriptionPlan: string
}

export const tenantService = {
  /**
   * Lista todas as empresas/academias disponíveis para o super-admin.
   * Endpoint: GET /company (retorna todas para super-admin, só a própria para outros)
   */
  listForSuperAdmin: async (): Promise<Tenant[]> => {
    const companies = await http.get<CompanyDto[]>('/company')

    return companies.map(mapCompanyToTenant)
  },

  /**
   * Obtém a empresa do usuário atual (usuário comum ou admin de empresa).
   * Usa o endpoint existente: GET /company/current
   */
  getCurrentUserCompany: async (): Promise<Tenant> => {
    const company = await http.get<CompanyDto>('/company/current')

    return mapCompanyToTenant(company)
  },
}

// Mapeia Company DTO para Tenant
function mapCompanyToTenant(company: CompanyDto): Tenant {
  return {
    id: company.id,
    name: company.razaoSocial,
    plan: mapPlanLabel(company.subscriptionPlan),
  }
}

// Mapeia subscriptionPlan para label amigável
function mapPlanLabel(plan: string): string {
  const planMap: Record<string, string> = {
    free: 'Free',
    pro: 'Pro',
  }

  return planMap[plan] || plan
}
